import { Component, Input, OnInit } from '@angular/core';
import { GridDataResult, DataStateChangeEvent } from '@progress/kendo-angular-grid';
import { process, State } from '@progress/kendo-data-query';
import { CSEService } from '../../services/cse.service';
import {
    CarrierRepsAssigned
    , CarrierRepsAssignedAvailable
} from '../../models/models';

@Component({
    selector: 'carrier-rep-assigned',
    templateUrl: './carrier-rep-assigned.component.html',
    standalone: false
})
export class CarrierRepAssigned implements OnInit {
    @Input() quoteOrderLineID: number = 0;
    public isLoading: boolean = false;

    //public selectedCarrierReps: Employee[] = [];
    public carrierRepsAssigned: CarrierRepsAssigned[] = [];
    public carrierRepsAssignedAvailable: CarrierRepsAssignedAvailable[] = [];
    public carrierRepsAssignedAvailableState: State = { sort: [{ dir: 'asc', field: 'csrEmployeeName' }] };
    public carrierRepsAssignedAvailableView: GridDataResult = { data: [], total: 0 };

    constructor(private cseService: CSEService) {
    }

    ngOnInit() {
        this.carrierRepsAssigned.length = 0;
        this.carrierRepsAssignedAvailable.length = 0;
        this.getCarrierRepsAvailable();
        console.log("ngOnInit", this.carrierRepsAssigned, this.carrierRepsAssignedAvailable);
    }

    private getCarrierRepsAvailable() {
        this.cseService.getCarrierRepsAssignedAvailableByQuoteOrderLineID(this.quoteOrderLineID).subscribe(result => {
            var csrList = result.resultCollection;
            csrList = csrList.sort((left, right): number => {
                if (left.csrEmployeeName < right.csrEmployeeName) return -1;
                if (left.csrEmployeeName > right.csrEmployeeName) return 1;
                return 0;
            });
            this.carrierRepsAssignedAvailable = csrList;
            this.carrierRepsAssignedAvailableView = process(this.carrierRepsAssignedAvailable, this.carrierRepsAssignedAvailableState);
        });
    }

    public carrierRepsAssignedAvailableStateChange(state: DataStateChangeEvent): void {
        this.carrierRepsAssignedAvailableState = state;
        //console.log("carrierRepsAssignedAvailableStateChange", this.carrierRepsAssignedAvailable);
        this.carrierRepsAssignedAvailableView = process(this.carrierRepsAssignedAvailable, this.carrierRepsAssignedAvailableState);
        //this.setOrderStopGrid();
    }

    public setCarrierRepsAssigned(rep: CarrierRepsAssignedAvailable) {
        if (rep.quoteOrderLineID > 0) {
            //rep.quoteOrderLineID = 0;
            this.deleteCarrierRepsAssigned(rep);
        }
        else {
            rep.quoteOrderLineID = this.quoteOrderLineID;
            this.saveCarrierRepsAssigned(rep);
        }
        //console.log("setCarrierRepsAssigned", rep, this.carrierRepsAssignedAvailable, this.carrierRepsAssigned);
    }

    public deleteCarrierRepsAssigned(rep: CarrierRepsAssignedAvailable) {
        this.isLoading = true;
        this.cseService.deleteCarrierRepsAssigned(rep.carrierRepsAssignedID).subscribe(result => {
            this.isLoading = false;
            var idx = this.carrierRepsAssignedAvailable.findIndex(c => c.csrEmployeeID == rep.csrEmployeeID);
            this.carrierRepsAssignedAvailable[idx].carrierRepsAssignedID = 0;
            this.carrierRepsAssignedAvailable[idx].quoteOrderLineID = 0;
            this.carrierRepsAssignedAvailableView = process(this.carrierRepsAssignedAvailable, this.carrierRepsAssignedAvailableState);
        });
        //console.log("saveCarrierRepsAssigned", this.carrierRepsAssigned);
    }

    public saveCarrierRepsAssigned(rep: CarrierRepsAssignedAvailable) {
        this.isLoading = true;
        var saveRep: CarrierRepsAssigned = {
            carrierRepsAssignedId: 0,
            employeeID: rep.csrEmployeeID,
            quoteOrderLineID: rep.quoteOrderLineID,
            assignedByEmployeeID: parseInt(localStorage.getItem('EmployeeId')!),
            transDate: new Date()
        };
        this.cseService.saveCarrierRepsAssigned(saveRep).subscribe(result => {
            this.isLoading = false;
            var updatedRep: CarrierRepsAssigned = result.resultCollection[0];
            var idx = this.carrierRepsAssignedAvailable.findIndex(c => c.csrEmployeeID == rep.csrEmployeeID);
            this.carrierRepsAssignedAvailable[idx].carrierRepsAssignedID = updatedRep.carrierRepsAssignedId;
            this.carrierRepsAssignedAvailable[idx].quoteOrderLineID = rep.quoteOrderLineID;
            this.carrierRepsAssignedAvailableView = process(this.carrierRepsAssignedAvailable, this.carrierRepsAssignedAvailableState);
            //rep.carrierRepsAssignedID = saveRep.carrierRepsAssignedId;
            //rep.quoteOrderLineID = saveRep.quoteOrderLineID;
        });
        console.log("saveCarrierRepsAssigned", this.carrierRepsAssigned, saveRep);
    }

    public saveAllCarrierRepsAssigned() {
        this.carrierRepsAssigned.length = 0;
        for (var i = 0; i < this.carrierRepsAssignedAvailable.length; i++) {
            if (this.carrierRepsAssignedAvailable[i].quoteOrderLineID > 0) {
                var rep: CarrierRepsAssigned = {
                    carrierRepsAssignedId: 0,
                    employeeID: this.carrierRepsAssignedAvailable[i].csrEmployeeID,
                    quoteOrderLineID: this.carrierRepsAssignedAvailable[i].quoteOrderLineID,
                    assignedByEmployeeID: parseInt(localStorage.getItem('EmployeeId')!),
                    transDate: new Date()
                };
                this.carrierRepsAssigned.push(rep);
            }
        }
        this.isLoading = true;
        this.cseService.saveAllCarrierRepsAssigned(this.quoteOrderLineID, this.carrierRepsAssigned).subscribe(result => {
            this.isLoading = false;
            this.carrierRepsAssigned = result.resultCollection;
        });
        //console.log("saveCarrierRepsAssigned", this.carrierRepsAssigned);
    }

    //public carrierRepsChange(evt: any) {
    //    this.selectedCarrierReps = Array.from(evt);
    //    //console.log(evt, this.selectedCarrierReps);
    //}
}
